import { useState } from "react";
import { useRequest } from "@umijs/max";
import { queryAssociatedTeamDocList, deleteAssociatedTeamDoc, queryWpsTeamDocList, saveTeamDoc, queryTeamDocSliceProgress } from "@/services/wpsKnowledge";
export default () => {
  const [teamDocList, setTeamDocList] = useState([])
  const [wpsTeamDocList, setWpsTeamDocList] = useState([])
  const [isShow, setIsShow] = useState(false)

  const { run: getTeamDocList, refresh: refreshTeamDocList } = useRequest(queryAssociatedTeamDocList, {
    manual: true,
    onSuccess: (data) => {
      if (data.status === 0) {
        setTeamDocList(data.payload)
      }
    }
  })


  const { run: deleteDoc } = useRequest(deleteAssociatedTeamDoc, {
    manual: true,
    onSuccess: (data) => {
      if (data.status === 0) {
        refreshTeamDocList()
      }
    }
  })

  const { run: getDocList } = useRequest(queryWpsTeamDocList, {
    manual: true,
    onSuccess: (data) => {
      if (data.status === 0) {
        setWpsTeamDocList(data.payload)
      }
    }
  })

  const { run: saveDoc } = useRequest(saveTeamDoc, {
    manual: true,
    onSuccess: (data) => {
      if (data.status === 0) {
        setIsShow(false)
        refreshTeamDocList()
      }
    }
  })

  return {
    getTeamDocList,
    teamDocList,
    deleteDoc,
    getDocList,
    wpsTeamDocList,
    saveDoc,
    isShow,
    setIsShow,
    setTeamDocList
  };
};
